import React, { useState, useEffect } from 'react'
import { postAPI } from '../../../app/api';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Modal from '../../../GlobalComponent/Modal';
// HTML Assets Base URL
const HTML_ASSETS_URL = 'https://retechprime.com/be-college-ex-students-club/html/';

export default function NewsSection() {

    const [NewsData, setNewsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [value, onChange] = useState(new Date());
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [calendarEvents, setCalendarEvents] = useState([]);
    const [selectedNews, setSelectedNews] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [clickedImg, setClickedImg] = useState(null);

    const handelRotationRight = () => {
        // No rotation needed for single event image
    };

    const handelRotationLeft = () => {
        // No rotation needed for single event image
    };

    const handleNewsClick = (e, news) => {
        e.preventDefault();
        setSelectedNews(news);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedNews(null);
    };

    const staticEvents = [
        { date: '05-06-2025', details: "Annual Foundation Day Celebration – Cultural programs & alumni meet." },
        { date: '23-10-2025', details: "Technical Seminar: Innovation & Engineering Trends for 2025." },
        { date: '22-11-2025', details: "Alumni Networking Dinner – Connect with seniors & industry experts." },
        { date: '05-12-2025', details: "Sports Day 2025 – Cricket, football & indoor games tournament." },
        { date: '06-12-2025', details: "Blood Donation Camp sponsored by B E College Ex-Students' Club." }
    ];

    const allEvents = [...staticEvents, ...calendarEvents];

    const parseEventDate = (dateString) => {
        if (!dateString) return null;
        if (dateString.includes('-')) {
            const parts = dateString.split('-');
            if (parts[0].length === 4) {
                return new Date(dateString);
            } else {
                const [day, month, year] = parts;
                return new Date(`${year}-${month}-${day}`);
            }
        }
        return new Date(dateString);
    };

    const handleDateClick = (date) => {
        const found = allEvents.find(ev => {
            const evDate = parseEventDate(ev.date);
            return evDate && evDate.toDateString() === date.toDateString();
        });
        setSelectedEvent(found || null);
        onChange(date);
    };

    const tileClassName = ({ date, view }) => {
        if (view === "month") {
            const isEventDay = allEvents.some(ev => {
                const evDate = parseEventDate(ev.date);
                return evDate && evDate.toDateString() === date.toDateString();
            });
            return isEventDay ? "event-date" : null;
        }
    };

    const fetchNews = async () => {
        try {
            setLoading(true);
            const response = await postAPI('news/list-section-data', {});
            if (response?.status === 1) {
                setNewsData(response?.data || []);
            }
        } catch (error) {
            console.error("Error fetching news:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchCalendarEvents = async () => {
        try {
            const response = await postAPI('calendar-events/list-published', {});
            if (response?.status === 1) {
                setCalendarEvents(response?.data || []);
            }
        } catch (error) {
            console.error("Error fetching calendar events:", error);
        }
    };

    useEffect(() => {
        fetchNews();
        fetchCalendarEvents();
    }, []);



    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString("en-IN", {
            day: "numeric",
            month: "long",
            year: "numeric",
        });
    };

    // Background image style for the news section
    const newsSectionStyle = {
        backgroundImage: `url(/images/from-html/home-banner.jpg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
    };
    const formatTime = (time) => {
        if (!time) return "";
        const [hours, minutes] = time.split(":");
        const hour = parseInt(hours, 10);
        const ampm = hour >= 12 ? "PM" : "AM";
        const formattedHour = hour % 12 || 12;
        return `${formattedHour}:${minutes} ${ampm}`;
    }
    const eventFormatDate = (dateStr) => {
        if (!dateStr) return "";
        const date = new Date(dateStr);

        const day = date.getDate();
        const month = date.toLocaleString("en-US", { month: "short" });
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    };

    return (
        <>
            <section className="news py-5" style={newsSectionStyle}>
                <div className="container-xxl container-lg container-fluid">
                    <div className="row">
                        {/* LEFT SIDE NEWS LIST */}
                        <div className="col-lg-12">
                            <div className="heading">
                                <h2 className="text-white">News</h2>
                                <p className="news-desc">Stay updated with the latest happenings of the B E College Ex–Students' Club. From cultural events and seminars to social initiatives and member achievements, our news section keeps you connected with all that's new and noteworthy within our vibrant alumni community.</p>
                            </div>
                            <div className="row mt-1">
                                {loading ? (
                                    <div className="col-12 text-center py-5">
                                        <div className="spinner-border text-light" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                ) : NewsData && NewsData.length > 0 ? (
                                    NewsData.map((news, index) => (
                                        <div className="col-lg-4" key={index}>
                                            <a href="#" className="news-card mb-3" onClick={(e) => handleNewsClick(e, news)}>
                                                <img
                                                    src={news.image || `${HTML_ASSETS_URL}assets/images/home/news-01.png`}
                                                    className="img-fluid"
                                                    alt={news.title}
                                                />
                                                <div className="news-overlay d-flex align-items-center justify-content-between">
                                                    <div>
                                                        <small>{formatDate(news.date)}</small>
                                                        <h3>{news.title}</h3>
                                                    </div>
                                                    <span className="btn keep-more-btn">→</span>
                                                </div>
                                            </a>
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-12 text-center py-5">
                                        <p className="text-muted">No news items available</p>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* RIGHT SIDE EVENTS & CALENDAR */}
                        <div className="col-lg-12 events">
                            <div className="heading text-lg-start text-center mt-4 mt-lg-0 mb-0">
                                <h2 className="text-white">Event</h2>
                                <p className="news-desc">Discover the diverse events of the BE. College Ex-Students' Club, including cultural programs, seminars, reunions, and social initiatives. Our events section highlights opportunities to connect, engage, and celebrate the spirit of our alumni community.</p>
                            </div>
                            <div className='row flx-dir'>
                                <div className='col-lg-8 order-2 order-md-1 order-lg-1'>
                                    {selectedEvent ? (
                                        <div className="event-box">
                                            <div className='row'>
                                                <div className='col-xl-6 col-lg-4 col-md-4'>
                                                    <div className='event-img' style={{ cursor: selectedEvent?.image ? 'pointer' : 'default' }} onClick={() => selectedEvent?.image && setClickedImg(selectedEvent.image)}>
                                                        {selectedEvent?.image ? (
                                                            <img src={selectedEvent.image} alt="Event" className='img-fluid' />
                                                        ) : (
                                                            <div className='no-image-placeholder'>
                                                                <i className='fa fa-calendar' style={{ fontSize: '48px', color: '#999' }}></i>
                                                                <p>No image available</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className='col-xl-6 col-lg-8 col-md-8'>
                                                    <div className='event-text'>
                                                        <h4>{selectedEvent?.title || 'Event Title'}</h4>
                                                        <small className="date-text">{eventFormatDate(selectedEvent?.date)} {selectedEvent?.time && '|'} {formatTime(selectedEvent?.time)}</small>
                                                        <p className="mb-0">{selectedEvent?.details || selectedEvent?.description}</p>
                                                        {selectedEvent?.download_url && (
                                                            <a href={selectedEvent.download_url} target="_blank" rel="noopener noreferrer" className='btn btn-danger mt-3'>Download</a>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="event-box no-event">
                                            <div className='row w-100 align-items-start'>
                                                <div className='col-lg-12 pe-0'>
                                                    <div className='text-center'>
                                                        <h4 className="date-text">Select a date</h4>
                                                        {/* <small className="date-text">{selectedEvent?.date}</small> */}
                                                        <p className="mb-0">No event yet today</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className='col-lg-4 order-1 order-md-2 order-lg-2 mb-3 mb-lg-0 mb-md-0'>
                                    <div className="calendar-box mt-0">
                                        <Calendar
                                            onChange={handleDateClick}
                                            value={value}
                                            tileClassName={tileClassName}
                                        />
                                    </div>
                                </div>

                            </div>
                            {/* {selectedEvent ? (
                                <div className="event-box d-flex align-items-center">
                                    <img src={`${HTML_ASSETS_URL}assets/images/icon/event-icon.svg`} alt="Event" />
                                    <div>
                                        <small className="date-text">{selectedEvent.date}</small>
                                        <p className="mb-0">{selectedEvent.details}</p>
                                    </div>
                                </div>
                            ) : (
                                <div className="event-box d-flex align-items-center">
                                    <img src={`${HTML_ASSETS_URL}assets/images/icon/event-icon.svg`} alt="Event" />
                                    <div>
                                        <small className="date-text">Select a date</small>
                                        <p className="mb-0">Click on a highlighted date to view event</p>
                                    </div>
                                </div>
                            )}

                            <div className="calendar-box mt-4">
                                <Calendar
                                    onChange={handleDateClick}
                                    value={value}
                                    tileClassName={tileClassName}
                                />
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>

            <NewsModal
                show={showModal}
                handleClose={handleCloseModal}
                news={selectedNews}
                formatDate={formatDate}
            />
            {clickedImg && (
                <div className='news-modal'>
                    <Modal
                        clickedImg={clickedImg}
                        // handelRotationRight={handelRotationRight}
                        setClickedImg={setClickedImg}
                    // handelRotationLeft={handelRotationLeft}
                    />
                </div>
            )}
        </>
    );
}

const NewsModal = ({ show, handleClose, news, formatDate }) => {
    if (!show || !news) return null;

    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-xl modal-dialog-centered big-modal" role="document">
                <div className="modal-content">
                    <div className="modal-header border-0 align-items-start py-4 pb-0">
                        <div className='align-items-center justify-content-between w-100'>
                            <h3 className="mt-0 mb-0 text-primary">{news.title}</h3>
                            <small className="text-muted my-2 d-inline-block">{formatDate(news.date)}</small>
                        </div>
                        <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-12 mb-3">
                                <figure>
                                    <img src={news.image} className="img-fluid" alt={news.title} />
                                </figure>
                            </div>
                            <div className="col-md-12">
                                <p dangerouslySetInnerHTML={{ __html: news.description }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
